import React from "react";
import ReactMarkdown from "react-markdown";

export default function MarkdownContent({ content }) {
  return (
    <ReactMarkdown
      components={{
        h1: ({ children }) => (
          <h1 className="text-xl font-bold mb-4" style={{ color: "var(--fb-text)", fontFamily: "Outfit" }}>
            {children}
          </h1>
        ),
        h2: ({ children }) => (
          <h2 className="text-base font-semibold mt-6 mb-2" style={{ color: "var(--fb-text)" }}>
            {children}
          </h2>
        ),
        h3: ({ children }) => (
          <h3 className="text-sm font-semibold mt-4 mb-1" style={{ color: "var(--fb-text)" }}>
            {children}
          </h3>
        ),
        p: ({ children }) => (
          <p className="text-sm mb-3 leading-relaxed" style={{ color: "var(--fb-text-muted)" }}>
            {children}
          </p>
        ),
        ul: ({ children }) => (
          <ul className="list-disc list-outside ml-4 mb-3 space-y-1 text-sm" style={{ color: "var(--fb-text-muted)" }}>
            {children}
          </ul>
        ),
        ol: ({ children }) => (
          <ol className="list-decimal list-outside ml-4 mb-3 space-y-1 text-sm" style={{ color: "var(--fb-text-muted)" }}>
            {children}
          </ol>
        ),
        li: ({ children }) => (
          <li className="leading-relaxed">{children}</li>
        ),
        strong: ({ children }) => (
          <strong className="font-semibold" style={{ color: "var(--fb-text)" }}>
            {children}
          </strong>
        ),
        em: ({ children }) => (
          <em className="italic">{children}</em>
        ),
        code: ({ inline, children }) =>
          inline ? (
            <code
              className="px-1 py-0.5 rounded text-xs font-mono"
              style={{ background: "var(--fb-border)", color: "var(--fb-text)" }}
            >
              {children}
            </code>
          ) : (
            <pre
              className="p-3 rounded-lg text-xs font-mono overflow-x-auto mb-3"
              style={{ background: "var(--fb-border)", color: "var(--fb-text)" }}
            >
              <code>{children}</code>
            </pre>
          ),
        table: ({ children }) => (
          <div className="overflow-x-auto mb-3">
            <table className="w-full text-sm border-collapse">
              {children}
            </table>
          </div>
        ),
        thead: ({ children }) => (
          <thead style={{ borderBottom: "1px solid var(--fb-border)" }}>{children}</thead>
        ),
        th: ({ children }) => (
          <th className="text-left py-1.5 pr-4 text-xs font-semibold uppercase tracking-wide" style={{ color: "#8B918B" }}>
            {children}
          </th>
        ),
        td: ({ children }) => (
          <td className="py-1.5 pr-4 align-top" style={{ color: "var(--fb-text-muted)", borderBottom: "1px solid var(--fb-border)" }}>
            {children}
          </td>
        ),
        hr: () => (
          <hr className="my-4" style={{ borderColor: "var(--fb-border)" }} />
        ),
      }}
    >
      {content}
    </ReactMarkdown>
  );
}
